<rpe-page-template title="Acreditación de Empresa para Certificación" route="main/landing">
  <ng-container slot="content">
    <div class="layout">
      <div class="content">
        <mat-card>
          <mat-card-content>
            <rpe-acreditacion-empresa-form [acreditacionEmpresaFormInput]="acreditacionEmpresaFormInput"
              (acreditacionEmpresaFormOutput)="onFormChange($event)"></rpe-acreditacion-empresa-form>
          </mat-card-content>
          <mat-card-actions align="end">
            <rpe-ui-button (onClick)="onCancel()">Cancelar</rpe-ui-button>
            <rpe-ui-button (onClick)="onConfirm()" [disabled]="!acreditacionFormOutput?.isValid"
              [isLoading]="isLoading">Confirmar</rpe-ui-button>
          </mat-card-actions>
        </mat-card>
      </div>
    </div>
  </ng-container>
</rpe-page-template>
